<template>
  <li
    class="vs-component vs-dropdown--item"
    :class="{ divider }"
    :style="itemStyle"
    @click="closeParent"
    @mouseover="hovered = true"
    @mouseout="hovered = false"
  >
    <router-link
      v-if="to"
      class="vs-dropdown--item-link"
      :class="[$attrs.class, { disabled }]"
      :style="$attrs.style"
      :to="to"
      v-bind="linkAttrs"
    >
      <slot />
    </router-link>
    <a
      v-else
      class="vs-dropdown--item-link"
      :class="[$attrs.class, { disabled }]"
      :style="$attrs.style"
      v-bind="linkAttrs"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: "VsDropdownItem",
  inheritAttrs: false,
  inject: ["vsDropdown"],
  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: false,
    };
  },
  computed: {
    dropdown() {
      return this.vsDropdown;
    },
    resolvedColor() {
      const color = this.dropdown.color;
      if (
        color.startsWith("#") ||
        color.startsWith("rgb") ||
        color.startsWith("hsl") ||
        color.startsWith("var(")
      ) {
        return color;
      }
      return `rgba(var(--vs-${color}), 1)`;
    },
    itemStyle() {
      if (!this.hovered) return {};
      return {
        color: this.resolvedColor,
        background: this.resolvedColor.replace(/,\s*1\)$/, ", .01)"),
      };
    },
    linkAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style"].forEach((key) => delete attrs[key]);
      return attrs;
    },
  },
  methods: {
    closeParent() {
      if (!this.disabled) this.dropdown.close();
    },
  },
};
</script>
